
export async function getOrders() {
  await new Promise((res) => setTimeout(res, 300));

  const orders = [
    {
      order_id: 'ORD-2023-001',
      priority: 'High',
      customer_details: {
        name: 'Tech Solutions Inc.',
        address: '123 Tech Street, San Francisco, CA',
        city: 'San Francisco',
        distance_km: 5.2
      },
      factory_details: {
        name: 'Factory-1',
        address: '100 Industrial Rd, San Francisco, CA'
      },
      trucknumber: 'TRK-SF-001',
      drivername: 'John Doe',
      status: 'in_transit',
      time_primary: '2:30 PM',
      time_secondary: '09:00 AM',
      date: '2023-12-08',
      remaining_km: 2.1,
      location:[24.71360000,46.82580000]
    },
    {
      order_id: 'ORD-2023-002',
      priority: 'Medium',
      customer_details: {
        name: 'Global Innovations Ltd.',
        address: '456 Innovation Blvd, San Francisco, CA',
        city: 'San Francisco',
        distance_km: 3.8
      },
      factory_details: {
        name: 'Factory-2',
        address: '200 Industrial Rd, San Francisco, CA'
      },
      trucknumber: 'TRK-SF-002',
      drivername: 'Jane Smith',
      status: 'delivered',
      time_primary: '—',
      time_secondary: '09:30 AM',
      date: '2023-12-08',
      remaining_km: 0,
      location:[24.66290000,46.54720000]
    },
    {
      order_id: 'ORD-2023-003',
      priority: 'Low',
      customer_details: {
        name: 'Apex Builders',
        address: '12 Market St, Oakland, CA',
        city: 'Oakland',
        distance_km: 12.4
      },
      factory_details: {
        name: 'Factory-3',
        address: '350 Industrial Park, Oakland, CA'
      },
      trucknumber: 'TRK-OAK-003',
      drivername: 'Ahmed Ali',
      status: 'pending',
      time_primary: '—',
      time_secondary: '08:30 AM',
      date: '2023-12-08',
      remaining_km: 12.4,
      location:[24.95740000,46.77280000]
    },
    {
      order_id: 'ORD-2023-003',
      priority: 'Low',
      customer_details: {
        name: 'Apex Builders',
        address: '12 Market St, Oakland, CA',
        city: 'Oakland',
        distance_km: 12.4
      },
      factory_details: {
        name: 'Factory-3',
        address: '350 Industrial Park, Oakland, CA'
      },
      trucknumber: 'TRK-OAK-003',
      drivername: 'Ahmed Ali',
      status: 'completed',
      time_primary: '—',
      time_secondary: '08:30 AM',
      date: '2023-12-08',
      remaining_km: 12.4
    }
  ];

  return orders;
}

export const ORDER_STATUSES = ['All Status', 'Pending', 'In Transit', 'Delivered', 'Completed'];